import { I18n } from '@calendly/i18n'
import classNames from 'classnames'

import ScopeDropdown from 'components/home_bar/scope_dropdown'
import { FilterSectionGroup } from 'components/meetings/filter_modal/components/filter_section_group'
import { meetingsFilterScopePopoverGlobalCss } from 'components/meetings/filter_modal/portaled_menu_styles'
import {
  presetFilterScopeControlCss,
  presetFilterScopeControlSurfaceCss,
  presetFilterScopeSelectCss,
  presetFilterSourceBlockCss,
} from 'components/meetings/filter_modal/preset_filter_sheet_styles'

import { MeetingsSchedulingSourceSwitch } from './meetings_scheduling_source_switch'

/**
 * Source block in the mobile/tablet preset filter sheet: scope + All meetings / Calendly only.
 *
 * The scheduling source switch is a draft control here: it edits the in-progress filter
 * params and the sheet's Apply button persists the change, so toggling it no longer fights
 * with (and gets reverted by) the Apply handler.
 */
export const MeetingsFilterSourceSection = ({ schedulingMethods, onSchedulingMethodsChange }) => (
  <FilterSectionGroup
    label={I18n.t('publisher.meetings.filter_modal.source.label')}
    wrapContent
    contentTestId="meetings-filter-source-section"
    contentClassName={classNames(presetFilterSourceBlockCss, meetingsFilterScopePopoverGlobalCss)}
  >
    <div className={presetFilterScopeControlCss} data-testid="meetings-filter-scope-control">
      <ScopeDropdown
        showSearch={false}
        useMeetingsFilterPortal
        className={presetFilterScopeSelectCss}
        controlClassName={presetFilterScopeControlSurfaceCss}
      />
    </div>
    <MeetingsSchedulingSourceSwitch
      fullWidth
      value={schedulingMethods}
      onChange={onSchedulingMethodsChange}
    />
  </FilterSectionGroup>
)
